import { assign } from 'lodash';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, FormControl } from '@angular/forms';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from '@medsurf/flat-facades';
import { ZodSharedValidator } from '@medsurf/flat-validators';

@Component({
    selector: 'medsurf-chapter-main-description',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './description.component.html',
    styleUrls: ['./description.component.scss'],
    standalone: false
})
export class DescriptionComponent {
  #isSubmitted = signal(false);
  #page: FlatModels.PageEntityModels.PageEntityType | null;
  descriptionForm = new FormGroup(
    {
      description: new FormControl(''),
    },
    {
      validators: ZodSharedValidator.validate(
        FlatModels.PageEntityModels.FolderSchema.pick({
          description: true,
        })
      ),
      updateOn: 'change'
    }
  );
  readonly FlatModels = FlatModels;

  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
              public nodeSharedFacade: FlatFacades.NodeSharedFacade) {
    // Update Page
    this.nodeSharedFacade.currentSelectedPage$.pipe(takeUntilDestroyed()).subscribe((page) => {
      this.#page = structuredClone(page);
      if (this.#page && FlatModels.PageEntityModels.PageHasDescription(this.#page)) {
        this.descriptionForm.reset({description: this.#page.description || ''});
      }
      this.#isSubmitted.set(false);
    });
  }

  onSubmit() {
    if (this.#isSubmitted() || this.descriptionForm.invalid || !this.#page) {
      return;
    }
    this.#isSubmitted.set(true);
    
    // Update Page
    const page = assign(this.#page, { description: this.descriptionForm.value['description'] });
    this.nodeSharedFacade.requestUpdatePage(page, 'history.page_update_description').subscribe({
      error: (result) => {
        ZodSharedValidator.handleError(result, this.alertControlFacade, this.descriptionForm);
        this.#isSubmitted.set(false);
      },
      next: () => {
        this.#isSubmitted.set(false);
      }
    });
  }
}
